import React, { memo } from 'react'
import { Box, Grid, Stack } from '@mui/material'
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons'
import styled from '@emotion/styled'

import BaseCard from '../shared/BaseCard/BaseCard'
import {
  CSS_FLEX_ALIGNED,
  CSS_FLEX_COLUMN,
  CSS_TRUNCATE_TEXT
} from '../../styles/common'
import Text from '../shared/text/Text'
import CustomButton from '../shared/buttons/CustomButton'
import FaIcon from '../shared/FaIcon/FaIcon'
import { formatTicks, toUpperFirstLetter } from '../../util/string.helpers'
import CustomTooltip from '../shared/CustomTooltip/CustomTooltip'
import { NFT_SUPPLY_MAX } from '../../constants/validation'
import NftMedia from './NftMedia'
import { buildTokenChipColor } from '../../util/token.helpers'

const NftCard = ({ nft, brandName, onNftDetailsClick, t }) => {
  const { name, supply, status, metadata } = nft
  const statusColor = buildTokenChipColor(status)
  return (
    <Grid item xs={6} sm={4} md={3} lg={3} xl={2} sx={{ width: '100%' }}>
      <BaseCard
        sx={{
          p: 0,
          width: '100%',
          ...CSS_FLEX_COLUMN
        }}
      >
        <NftMedia
          media={metadata?.media}
          coverImage={metadata?.legacy?.coverImage}
          onNftDetailsClick={() => onNftDetailsClick(nft)}
          sx={{
            borderRadius: '20px 20px 0 0',
            cursor: 'pointer'
          }}
        />
        <Grid container spacing={1} p={2}>
          <Grid item xs={12} sx={CSS_FLEX_COLUMN}>
            <Box sx={{ justifyContent: 'space-between', ...CSS_FLEX_ALIGNED }}>
              <Text
                label={name}
                variant='h5'
                fontWeight={700}
                sx={{
                  ...CSS_TRUNCATE_TEXT,
                  paddingRight: '5px'
                }}
              />
              <CustomTooltip label={toUpperFirstLetter(status)}>
                <CustomStatusDot color={statusColor} />
              </CustomTooltip>
            </Box>
            <Text label={brandName} variant='caption' />
            <Text
              label={`${t('nft.supply')}: ${formatTicks(
                supply
              )} / ${formatTicks(NFT_SUPPLY_MAX)}`}
              variant='caption'
            />
          </Grid>
        </Grid>
        <Box flexGrow={1} />
        <Stack
          spacing={1}
          direction={{ xs: 'column', sm: 'row' }}
          sx={{ alignItems: 'center', m: 2, mt: 0, justifyContent: 'stretch' }}
        >
          <CustomButton
            label={t('common.details')}
            onClick={() => onNftDetailsClick(nft)}
            startIcon={<FaIcon icon={faInfoCircle} width={18} />}
            noPadding
            size='small'
          />
        </Stack>
      </BaseCard>
    </Grid>
  )
}

export default memo(NftCard)

const CustomStatusDot = styled(Box)`
  border-radius: 50%;
  width: 7px;
  height: 7px;
  ${({ theme: { palette }, color }) =>
    `background-color: ${palette[color].main};`}
`
